// src/pages/LoginPage.jsx
import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import {
  Button,
  Input,
  Typography,
  Card,
  CardContent,
  Stack,
  Box,
  Link,
} from '@mui/joy';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const getErrorMessage = async (res) => {
    const body = await res.json().catch(() => null);

    if (body?.message) return body.message;
    if (body?.error) return body.error;

    return `Errore ${res.status}`;
  };

  const hasValidPermission = (user) => {
    if (user?.is_superadmin === true || user?.is_superadmin === 'true') {
      return true;
    }

    const enti = Array.isArray(user?.enti) ? user.enti : [];

    return enti.some((ente) => {
      const permessi = Array.isArray(ente?.permessi_ente)
        ? ente.permessi_ente
        : [];

      return permessi.some((permesso) => Number(permesso.menu_id) !== 9);
    });
  };

  const handleLogin = async () => {
    setError('');

    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_HOST}/loginNOENTE`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ username, password }),
        }
      );

      if (!res.ok) {
        throw new Error(await getErrorMessage(res));
      }

      const data = await res.json();

      if (data.user?.error === 'INVALID_PASSWORD') {
        throw new Error('Credenziali errate');
      }

      // 🔥 chiamata /me
      const meRes = await fetch(
        `${process.env.REACT_APP_SERVER_HOST}/me`,
        {
          credentials: 'include',
        }
      );

      if (!meRes.ok) {
        throw new Error(await getErrorMessage(meRes));
      }

      const meData = await meRes.json();
      const user = meData.user;

      // 🔒 controllo permessi
      if (!hasValidPermission(user)) {
        throw new Error(
          'Accesso non autorizzato: non hai permessi sufficienti.'
        );
      }

      const userId = user.id;
      const isSuperadmin =
        user?.is_superadmin === true || user?.is_superadmin === 'true';

      const enti = Array.isArray(user?.enti) ? user.enti : [];

      // 👉 primo ente ATTIVO
      const firstOrg = enti.find((e) => Number(e.stato_ente) === 1);

      // fallback
      const selectedOrg = firstOrg?.id_ente || enti[0]?.id_ente || null;

      // 💾 storage
      localStorage.setItem('isSuperadmin', JSON.stringify(isSuperadmin));
      localStorage.setItem('user', JSON.stringify(meData));
      localStorage.setItem('username', JSON.stringify(user));
      localStorage.setItem('userId', JSON.stringify(userId));

      if (selectedOrg) {
        localStorage.setItem('selectedOrg', selectedOrg);
        localStorage.setItem(
          'selectedOrgName',
          firstOrg?.nome_ente || ''
        );
      }

      navigate('/dashboard');
      window.location.reload();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <Typography
        level="body-sm"
        color="warning"
        textAlign="center"
        sx={{ mt: 2, maxWidth: 600, mx: 'auto' }}
      >
        L'accesso alla piattaforma è consentito esclusivamente agli utenti autorizzati.
      </Typography>

      <Card sx={{ maxWidth: 400, mx: 'auto', mt: 4, p: 3 }}>
        <CardContent>
          <Stack spacing={3}>
            {/* Logo */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                justifyContent: 'center',
              }}
            >
              <img
                src={`${process.env.REACT_APP_SERVER_HOST}/assets/img/logo/SEM.svg`}
                alt="Logo SEM"
                style={{ width: 40, height: 40 }}
              />
              <Typography component="h1" level="h5">
                SEM - Admin
              </Typography>
            </Box>

            {/* Titolo */}
            <Box>
              <Typography level="h4">Benvenuto su SEM 🚑</Typography>
              <Typography level="body-sm" color="neutral">
                Effettua il login
              </Typography>
            </Box>

            {/* Form */}
            <Input
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {error && (
              <Typography color="danger" level="body-sm">
                {error}
              </Typography>
            )}

            <Button onClick={handleLogin}>Accedi</Button>

            {/* Link */}
            <Box sx={{ textAlign: 'center' }}>
              <Link
                component={RouterLink}
                to="/change-password"
                level="body-sm"
              >
                Cambia password
              </Link>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}